<template>
  <UiDefaultPage title="Adresses">
    <div class="flex flex-col items-start gap-6 lg:flex-row">
      <div class="flex basis-1/2 flex-col gap-6 rounded-lg border bg-light p-6 shadow-lg">
        <h3 class="h4">
          Adresse de facturation
        </h3>
        <UpdateCustomerDetailsForm prefix="billing" />
      </div>
      <div class="flex basis-1/2 flex-col gap-6 rounded-lg border bg-light p-6 shadow-lg">
        <h3 class="h4">
          Adresse de livraison
        </h3>
        <UpdateCustomerDetailsForm prefix="shipping" />
      </div>
    </div>
  </UiDefaultPage>
</template>
